// extracted by mini-css-extract-plugin
export default {"modalWrapper":"SuspendCpSummary_modalWrapper__MCVcy"};